export default "__VITE_ASSET__Dj9$3pUX__"